module.exports = __webpack_public_path__ + "img/eua.6def32e5.png";